import { QueryFunctionContext } from "react-query";
import onBoardingApi from "./onBoardingApi";

export async function getAllHissaUsers(
  context: QueryFunctionContext,
): Promise<any> {
  return onBoardingApi
    .get(`idServer/getAllHissaUsers`)
    .then((res) => res.data.data)
    .catch((error: any) => error.data);
}
